import { Number3 } from '@abyss/3d-viewer';

export const DEFAULT_CUBOID_SCALE: Number3 = [1, 1, 1];
export const DEFAULT_CUBOID_ROTATION: Number3 = [0, 0, 0];
